/* eslint-disable camelcase */
import React, { useState, useRef, useEffect, useMemo, forwardRef, useImperativeHandle } from "react";
import "./InsuranceForm.css";
import { Accordion, Col, Row, Form } from "react-bootstrap";
import Autocomplete from "@mui/material/Autocomplete";
import TextField   from "@mui/material/TextField";
import { SingleCalendar } from "../../../../components";
import SignatureCanvas    from "react-signature-canvas";
import { ReactComponent as UploadIcon } from "../../../../assets/images/icons/solar_upload-line-duotone.svg";
import axios   from "axios";
import debounce from "lodash.debounce";
import { useTranslation } from '../../../../contexts/TranslationContext'
import Cookies from "js-cookie";
import { axiosGet } from "../../../../utils/apis/api";



/* ============================================================== */
const InsuranceForm = forwardRef(({ onChange = () => {}, showErrors = false, initialData = null,selectedDates ,url}, ref) => {
  const [previewImage, setPreviewImage] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const { t } = useTranslation();
  const Lang = Cookies.get("preferred_language") || "en";
  
  
  const [activeAccordionKeys, setActiveAccordionKeys] = useState(['0']);


  const insuranceTypeOptions = [
    { name: "Single Trip", label: t("SingleTrip") },
    { name: "Multi-Trip",  label: t("MultiTrip")  },
    { name: "Annual Coverage",      label: t("AnnualCoverage") },
  ];
  const coverageOptions = [
    { name: "Medical",       label: t("Medical") },
    { name: "Trip Cancellation",   label: t("TripCancellation") },
    { name: "Baggage Loss",  label: t("BaggageLoss") },
    { name: "Comprehensive", label: t("Comprehensive") },
  ];
  const paymentMethodOptions = [
    { name: "Credit Card",   label: t("CreditCard")   },
    { name: "PayPal",        label: t("PayPal")        },
    { name: "Bank Transfer", label: t("BankTransfer") },
  ];


  const fieldToAccordionMap = {
    // Personal Information
    full_name: '0',
    date_of_birth: '0',
    gender: '0',
    nationality: '0',
    passport_number: '0',
    phone: '0',
    email: '0',
    
    // Travel Insurance Details
    destination: '1',
    travel_start: '1',
    travel_end: '1',
    duration_trip: '1',
    insurance_type: '1',
    coverage_type: '1',
    
    // Payment & Billing
    payment_method: '2',
    billing_address: '2',
    invoice_required: '2',
    
    // Declaration & Signature
    agree_terms: '5',
    signature: '5',
    
    // Files
    file_passport_copy: '4'
  };

  const [form, setForm] = useState({
    /* personal */
    full_name:"", date_of_birth:null, gender:"", nationality:"",
    passport_number:"", passport_issue:null, passport_expiry:null,  phone:"", email:"", 
    /* insurance core */
    destination:null, destination_name:"",  travel_start:null, travel_end:null,
    duration_trip:"", num_travellers:"", medical_conditions:"",
    insurance_type:null, coverage_type:null,
    /* payment */
    payment_method:null, billing_address:"", invoice_required:"",
    /* travel & contact */
    flight_details:"", hotel_details:"", emergency_contact:"",
    /* files */
    files:{},
    /* declaration */
    agree_terms:false, signature:"",
  });

  const [errors, setErrors] = useState({});
  const inputRefs = useRef({});
  const sigPadRef = useRef();

  // Restore signature from initialData
  useEffect(() => {
    if (initialData?.signature && sigPadRef.current) {
      sigPadRef.current.fromDataURL(initialData.signature);
    }
  }, [initialData]);

  const [natQuery,   setNatQuery]   = useState("");
  const [natOptions, setNatOptions] = useState([]);
  const [natLoading, setNatLoading] = useState(false);

  // const fetchNationalities = useMemo(() =>
  //   debounce(async (q="")=>{
  //     try{
  //       setNatLoading(true);
  //       const params = q ? { search:q, limit:20 } : { limit:20 };
  //       const { data } = await axios.get(
  //         "https://viaggioerp.inter-netsys.com/api/method/alltimes.www.api.countries",
  //         { params }
  //       );
  //       setNatOptions(data.result.countries || []);
  //     }catch(e){ console.error(e); }
  //     finally   { setNatLoading(false); }
  //   },300)
  // ,[]);

  const fetchNationalities = useMemo(
    () =>
      debounce(async (q = "") => {
        try {
          setNatLoading(true);
          const params = q ? { search: q, limit: 20 } : { limit: 20 };
          const data = await axiosGet(
            "https://viaggioerp.inter-netsys.com/api/method/alltimes.www.api.countries",
            params
          );
          setNatOptions(data?.result?.countries || []);
        } catch (e) {
          console.error(e);
        } finally {
          setNatLoading(false);
        }
      }, 300),
    []
  );

  useEffect(()=>{ fetchNationalities(natQuery); },[natQuery, fetchNationalities]);
  useEffect(()=>()=>fetchNationalities.cancel(),[fetchNationalities]);

  const [destQuery,      setDestQuery]     = useState("");
  const [destOptions,    setDestOptions]   = useState([]);
  const [destLoading,    setDestLoading]   = useState(false);

  // const fetchDestinations = useMemo(() =>
  //   debounce(async (q="")=>{
  //     try{
  //       setDestLoading(true);
  //       const baseParams = { location_type:"City", limit:20 };
  //       const params = q.length>=2 ? {...baseParams, search:q} : baseParams;
  //       const { data } = await axios.get(
  //         "https://viaggioerp.inter-netsys.com/api/method/alltimes.www.api.locations",
  //         { params }
  //       );
  //       setDestOptions(data.result.locations || []);
  //     }catch(e){ console.error(e); }
  //     finally   { setDestLoading(false); }
  //   },300)
  // ,[]);

  const fetchDestinations = useMemo(
    () =>
      debounce(async (q = "") => {
        try {
          setDestLoading(true);
          const baseParams = { location_type: "City", limit: 20 };
          const params =
            q.length >= 2 ? { ...baseParams, search: q } : baseParams;
          const data = await axiosGet(
            "https://viaggioerp.inter-netsys.com/api/method/alltimes.www.api.locations",
            params
          );
          setDestOptions(data?.result?.locations || []);
        } catch (e) {
          console.error(e);
        } finally {
          setDestLoading(false);
        }
      }, 300),
    []
  );

  useEffect(()=>{ if(destQuery.length>=2) fetchDestinations(destQuery); },[destQuery,fetchDestinations]);
  useEffect(()=>()=>fetchDestinations.cancel(),[fetchDestinations]);

const required = {
  // Personal Information
  full_name: t("FullNameIsRequired"),
  date_of_birth: t("DateOfBirthIsRequired"),
  gender:t("GenderIsRequired"),
  nationality: t("NationalityIsRequired"),
  passport_number: t("PassportNumberIsRequired"),
  phone: t("PhoneNumberIsRequired"),
  email: t("EmailAddressIsRequired"),

  // Travel Details
  destination: t("DestinationCountryRequired"),
  travel_start: t("StartDateofTravelsRequired"),
  travel_end: t("EndDateOfTravelIsRequired"),
  duration_trip: t("TripDurationIsRequired"),

  // Insurance
  insurance_type: t("InsuranceTypeIsRequired"),
  coverage_type: t("CoverageTypeIsRequired"),

  // Payment
  payment_method: t("PaymentMethodIsRequired"),
  billing_address: t("BillingAddressIsRequired"),
  invoice_required: t("PleaseSpecifyIfInvoiceIsRequired"),

  // Declaration
  agree_terms: t("YouMustAgreeToTheTerms"),
  signature: t("SignatureIsRequired"),
};
  const requiredFiles = { passport_copy:t("PassportCopyIsRequired") };

  const rangeErrors = {
    trip:     t("EndDateMustBeAfterStartDate"),
    passport: t("ExpiryDateMustBeAfterIssueDate"),
  };

  const validate = () => {
    const errs = {};
    Object.entries(required).forEach(([k, msg]) => {
      if (!form[k] || (typeof form[k] === "string" && !form[k].trim()))
        errs[k] = msg;
    });
    Object.entries(requiredFiles).forEach(([k, msg]) => {
      if (!form.files[k]) errs[`file_${k}`] = msg;
    });
    if (form.email) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(form.email)) {
        errs.email = t("EmailValidation");
      }
    }

    if (form.phone) {
      const phoneRegex = /^\+?[0-9]{6,15}$/;
      if (!phoneRegex.test(form.phone))
        errs.phone = t("InvalidPhoneNumberFormat");
    }

    if (
      form.travel_start &&
      form.travel_end &&
      new Date(form.travel_start) > new Date(form.travel_end)
    )
      errs.travel_end = rangeErrors.trip;

    if (
      form.passport_issue &&
      form.passport_expiry &&
      new Date(form.passport_issue) > new Date(form.passport_expiry)
    )
      errs.passport_expiry = rangeErrors.passport;

    setErrors(errs);
    return Object.keys(errs).length === 0;
  };
  useEffect(()=>{ onChange(form, validate()); },[form]); // eslint-disable-line

  const handleFileChange = (k,f)=>{
    if(!f) return;
    setForm(p=>({...p,files:{...p.files,[k]:f}}));
    if(inputRefs.current[k]) inputRefs.current[k].value=null;
  };
  const handleFileRemove = (k)=>{
    setForm(p=>{ const files={...p.files}; delete files[k]; return {...p,files}; });
    if(inputRefs.current[k]) inputRefs.current[k].value=null;
  };
  const truncate = (n, max = 28) => (!n ? "" : n.length <= max ? n : `${n.slice(0,max-6)}...${n.slice(-5)}`);
  const fileDisplayName = (f) => typeof f === "string" ? f.split("/").pop() : f.name;
  const err = (f)=>showErrors && errors[f];

  /* ---------- Helper Autocomplete ---------- */
  const Auto = ({options,value,setValue,placeholder})=>(
    <Autocomplete
      fullWidth
      options={options}
      getOptionLabel={(o)=>o.label}
      value={value ? options.find(o=>o.name===value) : null}
      onChange={(_,v)=>setValue(v?.name||null)}
      renderInput={(params)=><TextField {...params} size="small" placeholder={placeholder||t("Select")} />}
    />
  );


  useEffect(()=>{
  if(!initialData) return;
  const toDate = (s)=> (s ? new Date(s) : null);
  setForm({
    ...initialData,
    destination_name : initialData.destination_name || "",
    date_of_birth     : toDate(initialData.date_of_birth),
    passport_issue    : toDate(initialData.passport_issue),
    passport_expiry   : toDate(initialData.passport_expiry),
    travel_start      : toDate(initialData.travel_start),
    travel_end        : toDate(initialData.travel_end),
  });
  // نعلِم الأبّ بأنّ البيانات جاهزة
  onChange(initialData, true);
},[initialData]); // NEW


 const scrollToFirstError = () => {
    const firstErrorKey = Object.keys(errors)[0];
    if (firstErrorKey) {
      // Expand accordion section containing the error
      const accordionKey = fieldToAccordionMap[firstErrorKey];
      if (accordionKey && !activeAccordionKeys.includes(accordionKey)) {
        setActiveAccordionKeys(prev => [...prev, accordionKey]);
      }

      // Scroll to field after accordion expands
      setTimeout(() => {
        const element = document.getElementById(`field-${firstErrorKey}`);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }, 300); // Allow time for accordion to expand
    }
  };

  // Expose scroll method via ref
  useImperativeHandle(ref, () => ({
    scrollToFirstError
  }));

  // Auto-expand accordions when errors appear
  useEffect(() => {
    if (showErrors && Object.keys(errors).length > 0) {
      const errorAccordionKeys = Object.keys(errors)
        .map(field => fieldToAccordionMap[field])
        .filter(key => key !== undefined);
      
      setActiveAccordionKeys(prev => [
        ...prev,
        ...errorAccordionKeys.filter(key => !prev.includes(key))
      ]);
    }
  }, [showErrors, errors]);


   

  /* ─────── JSX ─────── */
  return (
    <Accordion
      alwaysOpen
      className="hotel-form-accordion services-flights-form-accordion-container"
      activeKey={activeAccordionKeys}
      onSelect={(keys) => setActiveAccordionKeys(keys)}
    >
      {/* 1. Personal Information */}
      <Accordion.Item eventKey="0" className="hotel-form-accordion-item">
        <Accordion.Header className="hotel-form-accordion-header">
          1. {t("PersonalInformation")}
        </Accordion.Header>
        <Accordion.Body className="hotel-form-accordion-body">
          <Row>
            {/* Full name */}
            <Col xl={4} md={6}>
              <div className="hotel-form-input-container" id="field-full_name">
                <label className="hotel-form-input-label">
                  {t("FullName")} ({t("AsPerPassport")}) <span>*</span>
                </label>
                <input
                  className="hotel-form-input"
                  value={form.full_name}
                  onChange={(e) =>
                    setForm((p) => ({ ...p, full_name: e.target.value }))
                  }
                  placeholder={t("FullName")}
                />
                {err("full_name") && (
                  <div className="field-error">{errors.full_name}</div>
                )}
              </div>
            </Col>

            {/* Date of Birth */}
            <Col xl={4} md={6}>
              <div
                className="hotel-form-input-container"
                id="field-date_of_birth"
              >
                <label className="hotel-form-input-label">
                  {t("DateOfBirth")} <span>*</span>
                </label>
                <SingleCalendar
                  value={form.date_of_birth}
                  onChange={(e) =>
                    setForm((p) => ({ ...p, date_of_birth: e.value }))
                  }
                  placeholder={t("DateOfBirth")}
                  showTime={false}
                />
                {err("date_of_birth") && (
                  <div className="field-error">{errors.date_of_birth}</div>
                )}
              </div>
            </Col>

            {/* Gender */}
            <Col xl={4} md={6}>
              <div className="hotel-form-input-container" id="field-gender">
                <label className="hotel-form-input-label">
                  {t("Gender")} <span>*</span>
                </label>
                <Form.Select
                  size="sm"
                  value={form.gender}
                  onChange={(e) =>
                    setForm((p) => ({ ...p, gender: e.target.value }))
                  }
                  className="hotel-form-input select-dropdown"
                >
                  <option value="" disabled>
                    {t("SelectGender")}
                  </option>
                  <option value="Male">{t("Male")}</option>
                  <option value="Female">{t("Female")}</option>
                </Form.Select>
                {err("gender") && (
                  <div className="field-error">{errors.gender}</div>
                )}
              </div>
            </Col>

            {/* Nationality */}
            <Col xl={4} md={6}>
              <div
                className="hotel-form-input-container"
                id="field-nationality"
              >
                <label className="hotel-form-input-label">
                  {t("Nationality")} <span>*</span>
                </label>
                <Autocomplete
                  options={natOptions}
                  loading={natLoading}
                  getOptionLabel={(o) => o.name || ""}
                  value={
                    natOptions.find((o) => o.name === form.nationality) || null
                  }
                  onInputChange={(_, v) => setNatQuery(v)}
                  onChange={(_, v) =>
                    setForm((p) => ({ ...p, nationality: v?.name || "" }))
                  }
                  sx={{
                      ".MuiAutocomplete-inputRoot": {
                        fontSize: "12px",
                        flexDirection: Lang === "ar" ? "row-reverse" : "row",
                      },
                      ".MuiAutocomplete-endAdornment": {
                        left:
                          Lang === "ar" ? "9 !important" : "unset !important",
                        right:
                          Lang === "ar" ? "unset !important" : "9 !important",
                      },
                      ".MuiInputBase-input": {
                        textAlign: Lang === "ar" ? "right" : "left",
                      },
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      size="small"
                      placeholder={t("SelectNationality")}
                      InputProps={{
                          ...params.InputProps,
                          style: {
                            direction: Lang === "ar" ? "rtl" : "ltr",
                          },
                          sx: {
                            backgroundColor: "#FFF",
                            borderRadius: "6px",
                            padding: "9px 15px !important",
                            fontFamily: '"Dmsans400"',
                            fontSize: "14px !important",
                            fontWeight: 400,
                            letterSpacing: "0.25px",
                          },
                      }}
                    />
                  )}
                />
                {err("nationality") && (
                  <div className="field-error">{errors.nationality}</div>
                )}
              </div>
            </Col>

            {/* Passport Number */}
            <Col xl={4} md={6}>
              <div
                className="hotel-form-input-container"
                id="field-passport_number"
              >
                <label className="hotel-form-input-label">
                  {t("PassportNumber")} <span>*</span>
                </label>
                <input
                  className="hotel-form-input"
                  value={form.passport_number}
                  onChange={(e) =>
                    setForm((p) => ({ ...p, passport_number: e.target.value }))
                  }
                  placeholder={t("PassportNumber")}
                />
                {err("passport_number") && (
                  <div className="field-error">{errors.passport_number}</div>
                )}
              </div>
            </Col>

            {/* Phone */}
            <Col xl={4} md={6}>
              <div className="hotel-form-input-container" id="field-phone">
                <label className="hotel-form-input-label">
                  {t("ContactNumber")} ({t("Phone")}) <span>*</span>
                </label>
                <input
                  className="hotel-form-input"
                  value={form.phone}
                  onChange={(e) =>
                    setForm((p) => ({ ...p, phone: e.target.value }))
                  }
                  placeholder={t("PhoneNumber")}
                />
                {err("phone") && (
                  <div className="field-error">{errors.phone}</div>
                )}
              </div>
            </Col>

            {/* Email */}
            <Col xl={4} md={6}>
              <div className="hotel-form-input-container" id="field-email">
                <label className="hotel-form-input-label">
                  {t("Email")} <span>*</span>
                </label>
                <input
                  type="email"
                  className="hotel-form-input"
                  value={form.email}
                  onChange={(e) =>
                    setForm((p) => ({ ...p, email: e.target.value }))
                  }
                  placeholder={t("Email")}
                />
                {err("email") && (
                  <div className="field-error">{errors.email}</div>
                )}
              </div>
            </Col>
          </Row>
        </Accordion.Body>
      </Accordion.Item>

      {/* 2. Travel Insurance Details */}
      <Accordion.Item eventKey="1" className="hotel-form-accordion-item">
        <Accordion.Header className="hotel-form-accordion-header">
          2. {t("TravelInsuranceDetails")}
        </Accordion.Header>
        <Accordion.Body className="hotel-form-accordion-body">
          <Row>
            {/* Destination (Autocomplete جديد) */}
            <Col xl={4} md={6}>
              <div
                className="hotel-form-input-container"
                id="field-destination"
              >
                <label className="hotel-form-input-label">
                  {t("DestinationCountry")} / {t("Countries")} <span>*</span>
                </label>

                <Autocomplete
                  options={destOptions}
                  loading={destLoading}
                  getOptionLabel={(o) => {
                    const city = (o.location_name || "")
                      .replace(/\s+/g, " ")
                      .trim();
                    const parent = (o.parent_location_name || "")
                      .replace(/\s+/g, " ")
                      .trim();
                    return parent ? `${city} (${parent})` : city;
                  }}
                  value={
                    form.destination
                      ? {
                          name: form.destination,
                          location_name: form.destination_name || "",
                        }
                      : null
                  }
                  onOpen={() => {
                    if (!destOptions.length) fetchDestinations();
                  }}
                  onInputChange={(_, v, r) => {
                    if (r === "input") setDestQuery(v);
                  }}
                  onChange={(_, v) =>
                    setForm((p) => ({
                      ...p,
                      destination: v?.name || null,
                      destination_name: v?.location_name || "",
                    }))
                  }
                  sx={{
                      ".MuiAutocomplete-inputRoot": {
                        fontSize: "12px",
                        flexDirection: Lang === "ar" ? "row-reverse" : "row",
                      },
                      ".MuiAutocomplete-endAdornment": {
                        left:
                          Lang === "ar" ? "9 !important" : "unset !important",
                        right:
                          Lang === "ar" ? "unset !important" : "9 !important",
                      },
                      ".MuiInputBase-input": {
                        textAlign: Lang === "ar" ? "right" : "left",
                      },
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      size="small"
                      placeholder={`${t("DestinationCountry")} / ${t(
                        "Countries"
                      )}`}
                        InputProps={{
                          ...params.InputProps,
                          style: {
                            direction: Lang === "ar" ? "rtl" : "ltr",
                          },
                          sx: {
                            backgroundColor: "#FFF",
                            borderRadius: "6px",
                            padding: "9px 15px !important",
                            fontFamily: '"Dmsans400"',
                            fontSize: "14px !important",
                            fontWeight: 400,
                            letterSpacing: "0.25px",
                          },
                        }}
                    />
                  )}
                />

                {err("destination") && (
                  <div className="field-error">{errors.destination}</div>
                )}
              </div>
            </Col>

            {/* Duration */}
            <Col xl={4} md={6}>
              <div
                className="hotel-form-input-container"
                id="field-duration_trip"
              >
                <label className="hotel-form-input-label">
                  {t("DurationOfTrip")} ({t("Days")}) <span>*</span>
                </label>
                <input
                  type="number"
                  min={1}
                  className="hotel-form-input"
                  value={form.duration_trip}
                  onChange={(e) =>
                    setForm((p) => ({ ...p, duration_trip: e.target.value }))
                  }
                  onKeyDown={(e) =>
                    ["-", "e", "E", "+", ".", ","].includes(e.key) &&
                    e.preventDefault()
                  }
                  placeholder={`${t("DurationOfTrip")} (${t("Days")})`}
                />
                {err("duration_trip") && (
                  <div className="field-error">{errors.duration_trip}</div>
                )}
              </div>
            </Col>

            {/* Number of Travellers */}
            <Col xl={4} md={6}>
              <div className="hotel-form-input-container">
                <label className="hotel-form-input-label">
                  {t("NumberOfTravellers")} <span>*</span>
                </label>
                <input
                  type="number"
                  min={1}
                  className="hotel-form-input"
                  value={form.num_travellers}
                  onChange={(e) =>
                    setForm((p) => ({ ...p, num_travellers: e.target.value }))
                  }
                  onKeyDown={(e) =>
                    ["-", "e", "E", "+", ".", ","].includes(e.key) &&
                    e.preventDefault()
                  }
                  placeholder={t("NumberOfTravellers")}
                />
              </div>
            </Col>

            {/* Medical conditions */}
            <Col xl={4} md={6}>
              <div className="hotel-form-input-container">
                <label className="hotel-form-input-label">
                  {t("PreExistingMedicalConditions")}
                  <span>*</span>
                </label>
                <input
                  className="hotel-form-input"
                  value={form.medical_conditions}
                  onChange={(e) =>
                    setForm((p) => ({
                      ...p,
                      medical_conditions: e.target.value,
                    }))
                  }
                  placeholder="None"
                />
              </div>
            </Col>

            {/* Travel start / end */}
            <Col xl={4} md={6}>
              <div
                className="hotel-form-input-container"
                id="field-travel_start"
              >
                <label className="hotel-form-input-label">
                  {t("TravelStartDate")} <span>*</span>
                </label>
                <SingleCalendar
                  value={form.travel_start}
                  onChange={(e) =>
                    setForm((p) => ({ ...p, travel_start: e.value }))
                  }
                  placeholder={t("TravelStartDate")}
                  min={new Date(selectedDates.startDate)}
                  max={
                    form.travel_end
                      ? new Date(
                          Math.min(
                            new Date(form.travel_end).getTime(),
                            new Date(selectedDates.endDate).getTime()
                          )
                        )
                      : new Date(selectedDates.endDate)
                  }
                  viewDate={new Date(selectedDates.startDate)}
                />
                {err("travel_start") && (
                  <div className="field-error">{errors.travel_start}</div>
                )}
              </div>
            </Col>
            <Col xl={4} md={6}>
              <div className="hotel-form-input-container" id="field-travel_end">
                <label className="hotel-form-input-label">
                  {t("TravelEndDate")} <span>*</span>
                </label>
                <SingleCalendar
                  value={form.travel_end}
                  onChange={(e) =>
                    setForm((p) => ({ ...p, travel_end: e.value }))
                  }
                  placeholder={t("TravelEndDate")}
                  min={
                    form.travel_start
                      ? new Date(
                          Math.max(
                            new Date(form.travel_start).getTime(),
                            new Date(selectedDates.startDate).getTime()
                          )
                        )
                      : new Date(selectedDates.startDate)
                  }
                  max={new Date(selectedDates.endDate)}
                  viewDate={new Date(selectedDates.endDate)}
                />
                {err("travel_end") && (
                  <div className="field-error">{errors.travel_end}</div>
                )}
              </div>
            </Col>

            {/* Insurance type & coverage */}
            <Col xl={4} md={6}>
              <div
                className="hotel-form-input-container"
                id="field-insurance_type"
              >
                <label className="hotel-form-input-label">
                  {t("TypeOfInsurance ")} <span>*</span>
                </label>
                <Auto
                  options={insuranceTypeOptions}
                  value={form.insurance_type}
                  setValue={(v) =>
                    setForm((p) => ({ ...p, insurance_type: v }))
                  }
                />
                {err("insurance_type") && (
                  <div className="field-error">{errors.insurance_type}</div>
                )}
              </div>
            </Col>
            <Col xl={4} md={6}>
              <div
                className="hotel-form-input-container"
                id="field-coverage_type"
              >
                <label className="hotel-form-input-label">
                  {t("CoverageType")} <span>*</span>
                </label>
                <Auto
                  options={coverageOptions}
                  value={form.coverage_type}
                  setValue={(v) => setForm((p) => ({ ...p, coverage_type: v }))}
                />
                {err("coverage_type") && (
                  <div className="field-error">{errors.coverage_type}</div>
                )}
              </div>
            </Col>
          </Row>
        </Accordion.Body>
      </Accordion.Item>

      {/* 3. Payment & Billing */}
      <Accordion.Item eventKey="2" className="hotel-form-accordion-item">
        <Accordion.Header className="hotel-form-accordion-header">
          3. {t("PaymentAndBillingInformation")}
        </Accordion.Header>
        <Accordion.Body className="hotel-form-accordion-body">
          <Row>
            {/* Payment method */}
            <Col xl={4} md={6}>
              <div
                className="hotel-form-input-container"
                id="field-payment_method"
              >
                <label className="hotel-form-input-label">
                  {t("PaymentMethod")} <span>*</span>
                </label>
                <Auto
                  options={paymentMethodOptions}
                  value={form.payment_method}
                  setValue={(v) =>
                    setForm((p) => ({ ...p, payment_method: v }))
                  }
                />
                {err("payment_method") && (
                  <div className="field-error">{errors.payment_method}</div>
                )}
              </div>
            </Col>

            {/* Billing address */}
            <Col xl={8} md={6}>
              <div
                className="hotel-form-input-container"
                id="field-billing_address"
              >
                <label className="hotel-form-input-label">
                  {t("BillingAddress")} <span>*</span>
                </label>
                <input
                  className="hotel-form-input"
                  value={form.billing_address}
                  onChange={(e) =>
                    setForm((p) => ({ ...p, billing_address: e.target.value }))
                  }
                  placeholder={t("BillingAddress")}
                />
                {err("billing_address") && (
                  <div className="field-error">{errors.billing_address}</div>
                )}
              </div>
            </Col>

            {/* Invoice Required */}
            <Col xl={12}>
              <div
                className="add-service-form-checkbox-container"
                id="field-invoice_required"
              >
                <div className="add-service-form-checkbox-title">
                  {t("InvoiceRequired?")}{" "}
                  <span style={{ color: "red" }}>*</span>
                </div>
                <Form className="add-service-form-checkboxes">
                  {["1", "0"].map((v) => (
                    <Form.Check
                      key={v}
                      inline
                      type="radio"
                      label={v === "1" ? t("Yes") : t("No")}
                      name="invoiceRequired"
                      value={v}
                      checked={form.invoice_required === v}
                      onChange={() =>
                        setForm((p) => ({ ...p, invoice_required: v }))
                      }
                      className="add-service-form-checkbox"
                    />
                  ))}
                </Form>
                {err("invoice_required") && (
                  <div className="field-error">{errors.invoice_required}</div>
                )}
              </div>
            </Col>
          </Row>
        </Accordion.Body>
      </Accordion.Item>

      {/* 4. Travel & Contact Details */}
      <Accordion.Item eventKey="3" className="hotel-form-accordion-item">
        <Accordion.Header className="hotel-form-accordion-header">
          4. {t("TravelAndContactDetails")}
        </Accordion.Header>
        <Accordion.Body className="hotel-form-accordion-body">
          <Row>
            {[
              {
                key: "flight_details",
                label: "FlightDetails",
                label2: "IfApplicable",
                mandatory: 0,
              },
              {
                key: "hotel_details",
                label: "HotelDetails",
                label2: "IfApplicable",
                mandatory: 0,
              },
              {
                key: "emergency_contact",
                label: "EmergencyContactAndRelationship",
                label2: "",
                mandatory: 1,
              },
            ].map(({ key, label, label2, mandatory }) => (
              <Col xl={4} md={6} key={key}>
                <div
                  className="hotel-form-input-container"
                  id="field-file_passport_copy"
                >
                  <label className="hotel-form-input-label">
                    {t(label)} {label2 ? `(${t(label2)})` : ""}{" "}
                    {mandatory ? <span>*</span> : null}
                  </label>
                  <input
                    className="hotel-form-input"
                    value={form[key]}
                    onChange={(e) =>
                      setForm((p) => ({ ...p, [key]: e.target.value }))
                    }
                    placeholder={t(label)}
                  />
                </div>
              </Col>
            ))}
          </Row>
        </Accordion.Body>
      </Accordion.Item>

      {/* 5. Supporting Documents */}
      <Accordion.Item eventKey="4" className="hotel-form-accordion-item">
        <Accordion.Header className="hotel-form-accordion-header">
          5. {t("SupportingDocuments")}
        </Accordion.Header>
        <Accordion.Body className="hotel-form-accordion-body">
          <Row>
            {[
              {
                key: "passport_copy",
                label: "PassportCopy",
                label2: "",
                mandatory: 1,
              },
              {
                key: "previous_insurance",
                label: "PreviousTravelInsurance",
                label2: "IfAny",
                mandatory: 0,
              },
              {
                key: "medical_reports",
                label: "MedicalReports",
                label2: "IfRequired",
                mandatory: 0,
              },
            ].map(({ key, label, label2, mandatory }) => {
              const file = form?.files[key];
              const isPdf =
                file?.name?.toLowerCase().endsWith(".pdf") ||
                (typeof file === "string" &&
                  file.toLowerCase().endsWith(".pdf"));
              return (
                <Col xl={6} md={6} key={key}>
                  <div className="hotel-form-input-container">
                    <label className="hotel-form-input-label">
                      {t(label)} {label2 ? `(${t(label2)})` : ""}{" "}
                      {mandatory ? <span>*</span> : null}
                    </label>
                    <div className="custom-upload-wrapper">
                      <input
                        id={`file-${key}`}
                        type="file"
                        accept=".pdf,.jpg,.jpeg,.png"
                        style={{ display: "none" }}
                        ref={(el) => (inputRefs.current[key] = el)}
                        onChange={(e) =>
                          handleFileChange(key, e.target.files[0])
                        }
                      />
                      {/* <label htmlFor={`file-${key}`} className="custom-upload-box">
                      {!form.files[key] ? (
                        <>
                          <span className="upload-placeholder">{t("Supported")}: JPEG, PNG, PDF</span>
                          <UploadIcon className="upload-svg-icon" />
                        </>
                      ) : (
                        <>
                          <span className="upload-filename">{truncate( fileDisplayName(form.files[key]))}</span>
                          <span
                            className="upload-remove"
                            onClick={(e) => {
                              e.preventDefault();
                              handleFileRemove(key);
                            }}
                          >
                            ×
                          </span>
                        </>
                      )}
                    </label> */}

                      {file ? (
                        <div className="custom-upload-box">
                          <div className="file-info">
                            {isPdf ? (
                              <a
                                href={
                                  typeof file === "string"
                                    ? `${url}${file}`
                                    : URL.createObjectURL(file)
                                }
                                target="_blank"
                                rel="noopener noreferrer"
                                className="file-link"
                              >
                                {truncate(fileDisplayName(file))}
                                <span className="file-type-badge">PDF</span>
                              </a>
                            ) : (
                              <span className="file-name">
                                {truncate(fileDisplayName(file))}
                              </span>
                            )}
                          </div>

                          <div className="file-actions">
                            <button
                              type="button"
                              className="file-action-btn view-file-btn"
                              onClick={() => {
                                if (isPdf) {
                                  window.open(
                                    typeof file === "string"
                                      ? `${url}${file}`
                                      : URL.createObjectURL(file),
                                    "_blank"
                                  );
                                } else {
                                  const imageUrl =
                                    typeof file === "string"
                                      ? `${url}${file}`
                                      : URL.createObjectURL(file);
                                  setPreviewImage(imageUrl);
                                  setShowModal(true);
                                }
                              }}
                            >
                              {isPdf ? t("View") : t("Preview")}
                            </button>

                            <button
                              type="button"
                              className="file-action-btn remove-file-btn"
                              onClick={(e) => {
                                e.preventDefault();
                                handleFileRemove(key);
                              }}
                            >
                              {t("Remove")}
                            </button>
                          </div>
                        </div>
                      ) : (
                        <label
                          htmlFor={`file-${key}`}
                          className="custom-upload-box"
                        >
                          <span className="upload-placeholder">
                            {t("Supported")}: {t("Jpeg")}, {t("Png")},{" "}
                            {t("Pdf")}
                          </span>
                          <UploadIcon className="upload-svg-icon" />
                        </label>
                      )}
                    </div>
                    {err(`file_${key}`) && (
                      <div className="field-error" style={{ marginTop: 5 }}>
                        {errors[`file_${key}`]}
                      </div>
                    )}
                  </div>
                </Col>
              );
            })}
          </Row>
        </Accordion.Body>
      </Accordion.Item>

      {/* 6. Declaration & Signature */}
      <Accordion.Item eventKey="5" className="hotel-form-accordion-item">
        <Accordion.Header className="hotel-form-accordion-header">
          6. {t("DeclarationAndSignature")}
        </Accordion.Header>
        <Accordion.Body className="hotel-form-accordion-body">
          <Row>
            {/* Terms */}
            <Col xl={12}>
              <div
                className="hotel-form-input-container"
                id="field-agree_terms"
              >
                <Form.Check
                  type="checkbox"
                  label={`${t("IAgreeToTheTermsAndConditions")}.`}
                  checked={form.agree_terms}
                  onChange={(e) =>
                    setForm((p) => ({ ...p, agree_terms: e.target.checked }))
                  }
                />
                {err("agree_terms") && (
                  <div className="field-error">{errors.agree_terms}</div>
                )}
              </div>
            </Col>

            {/* Signature */}
            <Col xl={6}>
              <label className="hotel-form-input-label">
                {t("Signature")} <span>*</span>
              </label>
              <div
                className="signature-container"
                style={{ position: "relative" }}
                id="field-signature"
              >
                <SignatureCanvas
                  ref={sigPadRef}
                  penColor="black"
                  canvasProps={{
                    width: 500,
                    height: 150,
                    className: "sigCanvas",
                  }}
                  onEnd={() =>
                    setForm((p) => ({
                      ...p,
                      signature: sigPadRef.current.toDataURL(),
                    }))
                  }
                />
                <button
                  type="button"
                  title="Clear"
                  onClick={() => {
                    sigPadRef.current.clear();
                    setForm((p) => ({ ...p, signature: "" }));
                  }}
                  style={{
                    position: "absolute",
                    top: 8,
                    right: 40,
                    background: "none",
                    border: "none",
                    fontSize: 18,
                  }}
                >
                  ⟳
                </button>
              </div>
              {err("signature") && (
                <div className="field-error">{errors.signature}</div>
              )}
            </Col>
          </Row>
        </Accordion.Body>
      </Accordion.Item>
      {previewImage && (
        <div
          className={`modal fade ${
            showModal ? "show d-block" : ""
          } service-files-modal`}
          tabIndex="-1"
          role="dialog"
          style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
          onClick={() => setShowModal(false)}
        >
          <div className="modal-dialog modal-lg" role="document">
            <div className="modal-content">
              <button
                type="button"
                className="close"
                onClick={() => setShowModal(false)}
              ></button>
              <div className="service-image-file">
                <img
                  src={previewImage}
                  alt="preview"
                  style={{ maxWidth: "100%" }}
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </Accordion>
  );
});

export default InsuranceForm;
